import contentBlocks from 'services/common/contentBlocks';
import form from 'services/common/form';

export default {
	...contentBlocks,
	...form,
};
